import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

function ViewMore({
  className,
  onClick,
  text = "View",
  load = false,
  loadMore = false
}) {
  const [showMore, handleShowMore] = React.useState(true);

  const classNames = ["pw-view-more"];
  const arrowStyles = ["pw-view-more--icon"];

  if (className) classNames.push(className);
  if (showMore) arrowStyles.push("pw-rotate-zero");
  if (!showMore) arrowStyles.push("pw-rotate");

  const handleButton = () => {
    handleShowMore(!showMore);
    onClick();
  };

  const handleLoadButton = () => {
    onClick();
  };

  if (load) {
    return (
      <button
        onClick={() => handleLoadButton()}
        className={classNames.join(" ")}
      >
        {loadMore ? "Load more" : "Collapse"}
      </button>
    );
  } else {
    return (
      <button onClick={() => handleButton()} className={classNames.join(" ")}>
        {text} {showMore ? "more" : "less"}
        <FontAwesomeIcon
          className={arrowStyles.join(" ")}
          icon={faChevronRight}
        />
      </button>
    );
  }
}

ViewMore.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};

export default ViewMore;
